export enum LANGUAGES {
  English = "en",
  French = "fr",
  Russian = "ru",
  Spanish = "es",
}
